import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Company from '@/views/Company.vue'
import News from '@/views/News.vue'
import Contact from '@/views/Contact.vue'
import Recruit from '@/views/Recruit.vue'
import Ses from '@/views/Ses.vue'
import Develop from '@/views/Develop.vue'

Vue.use(VueRouter)

// 创建路由实例
const router = new VueRouter({
    // mode:'history',
    routes:[
      {
        path: '/',
        name: 'Home',
        component: Home,
        hidden: true
      },
      {
        path: '/home',
        name: 'Home',
        component: Home,
        hidden: true
      },
      {
        path: '/company',
        name: 'Company',
        component: Company,
        hidden: true
      },
      {
        path: '/news',
        name: 'News',
        component: News,
        hidden: true
      },
      {
        path: '/recruit',
        name: 'Recruit',
        component: Recruit,
        hidden: true
      },
      {
        path: '/ses',
        name: 'Ses',
        component: Ses,
        hidden: true
      },
      {
        path: '/dev',
        name: 'Develop',
        component: Develop,
        hidden: true
      },
      {
        path: '/contact',
        name: 'Contact',
        component: Contact,
        hidden: true
      },
    ]
})

// 【重要】添加全局后置守卫 - 必须放在这里
router.afterEach((to, from) => {
  window.scrollTo(0, 0);
})

// 导出路由实例
export default router